import { useContext, useCallback } from "react";
import { SiteVarsContext } from "../contexts/sitevars-context";
import { LeaderboardContext } from "../contexts/leaderboard-context";

export const useSiteVarsFunctions = () => {
  const { siteVarsData } = useContext(SiteVarsContext);
  const { leaderboardData } = useContext(LeaderboardContext);

  const formatGameWeek = () => {
    if (siteVarsData && siteVarsData.game_vars && siteVarsData.game_vars.currentWeek) {
      return `Week ${siteVarsData.game_vars.currentWeek}`;
    }
    return "Week N/A";
  };

  const getBiddingOpen = () => {
    if (siteVarsData && siteVarsData.game_vars && siteVarsData.game_vars.biddingOpen) {
      return siteVarsData.game_vars.biddingOpen;
    }
    return false;
  };

  const getTransfersOpen = () => {
    if (siteVarsData && siteVarsData.game_vars) {
      if (typeof siteVarsData.game_vars.transfersOpen !== 'undefined') {
        return Boolean(siteVarsData.game_vars.transfersOpen);
      }
      return Boolean(siteVarsData.game_vars.biddingOpen || (!siteVarsData.game_vars.windowFinalized && siteVarsData.game_vars.currentWindow));
    }
    return false;
  };

  const getScoresUpdatedTime = () => {
    if (siteVarsData && siteVarsData.game_vars && siteVarsData.game_vars.updateTime) {
      return siteVarsData.game_vars.updateTime;
    }
    return new Date();
  };
  
  const getTeamById = useCallback((teamId) => {
    if (siteVarsData && siteVarsData.static_vars && siteVarsData.static_vars.prem_teams) {
      const team = siteVarsData.static_vars.prem_teams.find(t => t.id === teamId);
      return team ? team : {};
    }
    return "Unknown Team";
  }, [siteVarsData]);


  const getPlayerPositionById = useCallback((playerId) => {
    if (siteVarsData && siteVarsData.static_vars && siteVarsData.static_vars.prem_positions) {
      const position = siteVarsData.static_vars.prem_positions.find(p => p.id === playerId);
      return position ? position : {};
    }
    return "Unknown Position";
  }, [siteVarsData]);

  const getManagerName = (clubId) => {
    const club = leaderboardData.find(club => club.clubId == clubId);
    return club ? club.managerName : `Unknown Manager (${clubId})`;
  };

  const getClubName = (clubId) => {
    const club = leaderboardData.find(club => club.clubId == clubId);
    return club ? club.clubName : `Unknown Club (${clubId})`;
  };

  const getAllowScrape = () => {
    if (siteVarsData && siteVarsData.game_vars && siteVarsData.game_vars.allowScrape) {
      return siteVarsData.game_vars.allowScrape;
    }
    return false;
  };
  
  const getCurrentWindow = () => {
    if (siteVarsData && siteVarsData.game_vars && siteVarsData.game_vars.currentWindow) {
      return siteVarsData.game_vars.currentWindow;
    }
    return false;
  };

  const getFplEvents = useCallback(() => {
    if (siteVarsData && siteVarsData.static_vars && siteVarsData.static_vars.fpl_events) {
      return siteVarsData.static_vars.fpl_events;
    }
    return [];
  }, [siteVarsData]);

  const getCurrentGameweekEvent = useCallback(() => {
    const events = getFplEvents();
    const currentWeek = siteVarsData?.game_vars?.currentWeek || 1;
    return events.find(e => e.id === currentWeek) || null;
  }, [siteVarsData, getFplEvents]);

  const getNextGameweekEvent = useCallback(() => {
    const events = getFplEvents();
    const currentWeek = siteVarsData?.game_vars?.currentWeek || 1;
    return events.find(e => e.id === currentWeek + 1) || null;
  }, [siteVarsData, getFplEvents]);

  const getOffersOpen = () => {
    return siteVarsData?.game_vars?.offersOpen || false;
  };

  const getPhase = () => {
    return siteVarsData?.game_vars?.phase || '1';
  };

  return {
    formatGameWeek,
    getBiddingOpen,
    getTransfersOpen,
    getScoresUpdatedTime,
    getTeamById,
    getPlayerPositionById,
    getManagerName,
    getClubName,
    getAllowScrape,
    getCurrentWindow,
    getFplEvents,
    getCurrentGameweekEvent,
    getNextGameweekEvent,
    getOffersOpen,
    getPhase
  };
};